import { FORM_TYPE } from "./custom-define-type";
import {
    MODEL_DATE,
    MODEL_EXPERIENCE_SPECIFIC_TEXT,
    MODEL_EXPERIENCE_TEXT,
    MODEL_EXPERIENCE_SELECTOR,
    MODEL_EXPERIENCE_MULTISELECT,
    MODEL_FILE_ALL,
    MODEL_REFERENCE_FILE,
    MODEL_EXPERIENCE_FILE,
    MODEL_BOOKING_FILE,
    MODEL_MULTI_SELECT,
    MODEL_SELECTOR,
    MODEL_CONTACT_SELECTOR,
    MODEL_SPECIFIC_SELECTOR,
    MODEL_CHILDREN_SELECTOR,
    MODEL_SPECIFIC_TEXT,
    MODEL_TEXT,
    MODEL_INTEGER_FIELD,
    MODEL_FLOAT_FIELD,
    MODEL_CHILDREN_TEXT,
    MODEL_CONTACT_TEXT,
    MODEL_EDUCATION_SPECIFIC_TEXT,
    MODEL_EDUCATION_SELECTOR,
    MODEL_EDUCATION_DATE,
    MODEL_CHILDREN_DATE,
    MODEL_BOOKING_DATE,
    MODEL_EXPERIENCE_DATE,
    MODEL_REFERENCE_DATE,
    MODEL_REFERENCE_TEXT,
    MODEL_REFERENCE_SELECTOR,
    MODEL_REFERENCE_MULTISELECT,
    MODEL_REFERENCE_SPECIFIC_TEXT,
    MODEL_CHILDREN_SPECIFIC_TEXT,
    MODEL_CONTACT_SPECIFIC_TEXT,
    MODEL_PET_TEXT,
    MODEL_PET_SPECIFIC_TEXT,
    MODEL_PET_SPECIFIC_SELECTOR,
    MODEL_BOOKING_TIME_PICKER,
    MODEL_BOOKING_SELECTOR,
    MODEL_BOOKING_TEXT,
    MODEL_BOOKING_MULTISELECT,
    MODEL_FILE_INFO_DATE,
    MODEL_FILE_INFO_SELECTOR,
    MODEL_FILE_INFO_SPECIFIC_TEXT,
    MODEL_REFERENCE_CHECK_MULTISELECT,
    MODEL_REFERENCE_CHECK_SELECTOR,
    MODEL_REFERENCE_CHECK_TEXT,
    MODEL_BOOLEAN_SELECTOR,
    MODEL_TIME_PICKER,
    MODEL_RELATIONSHIP_TEXT,
    MODEL_ADDRESS_SPECIFIC_TEXT,
    MODEL_ADDRESS_SELECTOR,
    MODEL_ADDRESS_TEXT
} from "./model-by-types";

export const MAP_OTHER_PROPERTIES = {
    PLACE_HOLDER: "Place Holder",
    OPTION_LIST: "Option List",
    //   MAX_LENGTH: "Max Length",
    //   VALUE_TYPE: "Value Type",
    FILE_TYPE: "File Type",
    SHOW_CONDITION: "Show Condition",
    SHOW_CONDITION_ADVANCE: "Advance Show Condition",
    SECONDARY_SHOW_CONDITION: "Secondary Show Condition",
    THIRD_SHOW_CONDITION: "Third Show Condition",
    HAS_OTHER: "Has Other", // In some case, checkbox or radio group has last option is 'Other', By select 'Other', it show a textbox to input custom value
    INITIAL_VIEW: "Initial View",
    SECTION_TYPE: "Section Type",
    DESCRIPTION: "Field Remark",
    BOTTOM_DESCRIPTION: "Field Remark (Bottom)",
    ADMIN_DESCRIPTION: "Field Remark (Admin Only)",
    GRADE_LIST: "Grade List",
    NUMBER_OF_COLUMN: "Number Of Columns",
    TEXTBOX_OPTION: "Textbox Option",
    ITEM_LIST: "Item List",
    HEADER_LIST: "Header List",
    INITIAL_VALUE: "Initial Value (Value when object is created)",
    DEFAULT_OPTION: "Default Value 1",
    DEFAULT_MULTI_OPTIONS: "Default Value 2",
    DEFAULT_VALUE: "Default Value 3",
    DEFAULT_VALUE_MULTI_LINES: "Default Value 4",
    DEFAULT_TIME: "Default Time",
    HIDE_SECTION_TITLE: "Hide Section Title", // In case of section, there are some case there is no section title
    SHOW_AT_TOP: "Show at top", // In case of upload image (for example: profile picture), display the image at top right of section
    HIDE_SALARY_PERIOD: "Hide Salary Period", // In case of salary range, Hide or show period (per year/month/week/hour)
    CUSTOMIZABLE_ITEM_LIST: "Customizable Item List", // Can add or remove item of checkbox table
    /*
    This property specifies if the model is share between several fields
    This is used to be compatible with older version, in which several fields are stored in one model
    For example: [firstName, lastName] store in 'features'
    */
    SHARE_MODEL: "Share Model",
    USE_DUPLICATE_MODEL: "Use Duplicate Model", // This property specifies if we want to reuse a model for more than 1 field
    HAS_CHECK_ALL: "Has Check All", // In case of checkbox group, display a checkbox to check all other checkboxes
    MINUTES_INTERVAL: "Minutes Interval",
    IS_24_HOUR_FORMAT: "is 24 Hour Format",
    IS_HTML: "Is HTML Format", // In case of checkbox group, display option by HTML format
    MAX_FILE_SIZE: "Max size",
    CUSTOM_LABEL: "Custom labels",
    CUSTOM_DATE_FORMAT: "Custom Date Format",
    APPEND_TO_BODY: "Show Datepicker Over Modal",
    SEARCHABLE: "Searchable",
    OPEN_ON_SELECT: "Open on Select",
    IS_ARRAY_MODEL: "Is Array Model",
    USE_TIME_PICKER: "Use Time Picker",
    EXCLUSIVE_OPTIONS: "Exclusive Options",
    IS_PRECONDITION_CHECK: "Is Precondition Check",
    HAS_NOTE: "Has Note Column",
    HAS_TIME_OFF: "Has Time Off Column",
    MESSAGE_ON_CLICK: "Show dialog when click item",
    COLLAPSE_BY_DEFAULT: "Collapse section by default",
    IS_PRIVATE: "Is Private",
    IS_ADMIN_ONLY_SECTION: "Is Admin Only Section",
    IS_ADMIN_ONLY: "Is Admin Only",
    SCROLL_TO_NEXT_ITEM_ON_SELECT: "Scroll to next item on Select",
    SHOW_IN_ADMIN_PANEL: "Only Show In Admin Panel",
    SHOW_IN_INTERVIEW_PANEL: "Only Show In Interview Panel",
    IS_HIDDEN: "Is Hidden",
    HIDE_DESCRIPTION_IN_VIEW_SCREEN: "Hide Field Remark in View Screen",
    HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN: "Hide Field Remark (Admin Only) in View Screen",
    EXCLUDE_CHILDREN_QUESTION: "Exclude Children Question",
    EXCLUDE_ADDRESS_QUESTION: "Exclude Address Question",
    EXCLUDE_REPEAT_BOOKING: "Exclude Repeat Booking",
    HAS_NUMBER_CANDIDATE_QUESTION: "Has Number of Candidate Question",
    HIDE_ADDITIONAL_DATES_QUESTION: "Hide Additional Dates Question",
    HIDE_LABEL: "Hide Label",
    SHOW_DOWNLOAD_FILE: "Show Download Reference Check File",
    BOOKING_REQUIRE_PAYMENT_INFO: "Payment information is required for booking",
    SELECT_ALL_DAYS_FOR_RECURRING_REQUESTS: "For recurring requests select all days",
    CHARGE_CLIENT_WHEN_ASSIGN_CANDIDATE: "Charge Client when candidate is assigned",
    BLANK_FILE_URL: "Has Blank Document Template",
    MIN_DURATION_ALLOW_EDIT_BOOKING: "Not allow edit booking within x hours",
    MIN_DURATION_ALLOW_ADD_BOOKING: "Not allow to book within x hours",
    HIDE_DETAIL_LABEL: "Hide Label when View Profile",
    SHOW_IN_PROFILE: "Show In User Profile",
    HIDE_IN_PROFILE: "Hide In User Profile",
    SHOW_IN_EDIT_PROFILE: "Show In Edit Profile Dialog",
    CHARGE_ON_SUBMIT: "Charge on Submit",
    HAS_DERIVED_MODEL: "Has derived model",
    IS_INTEGER_FIELD: "Is Integer Field",
    IS_FLOAT_FIELD: "Is Float Field",
    NOT_REQUIRED_IN_APPLICATION: "Not Required In Application",
    NOT_IN_APPLICATION: "Not on application but in profile",
    SHOW_AGE: "Show Age",
    SHOW_PASSED_TIMES: "Show how much time has passed",
    SHOW_PUBLIC_FORM_LINK: "Show Public Form Link",
    SHOW_IN_CANDIDATE_VIEW: "Show In Candidate View",
    IS_UNIQUE: "Unique Values",
    IS_IN_PLACEMENT_INFO_TAB: "Show in placement information tab",
    HAS_CONFIRM_FIELD: "Has Confirmation Field",
    EXCLUDE_FROM_SUMMARY_EMAIL: "Exclude from summary email",
    ADMIN_CAN_ADD_OPTION: "Admin Can Add Option",
    POPULATE_WEEK_AVAILABILITIES: "Populate Week Availabilities",
    INFO_ONCE_EXPIRED: "Information once expired",
    CAN_ADD_MULTIPLE: "Can add multiple",
    IS_A_PHONE_NUMBER: "Is a phone number",
    ONLY_ONE_CHECKED_ITEM_REQUIRED: "Only require 1 checked item"
};

export const MAP_MODEL_OTHER_PROPERTIES = {
    placeholder: [MAP_OTHER_PROPERTIES.PLACE_HOLDER],
    fileType: [MAP_OTHER_PROPERTIES.FILE_TYPE],
    showIf: [MAP_OTHER_PROPERTIES.SHOW_CONDITION],
    showIfAdvance: [MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE],
    showIfSecondary: [MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION],
    showIfThird: [MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION],
    showIfValue: [
        MAP_OTHER_PROPERTIES.SHOW_CONDITION,
        MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE
    ],
    showIfEmpty: [MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE],
    showIfValueNot: [MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE],
    showIfValueSecondary: [MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION],
    showIfValueThird: [MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION],
    hasOther: [MAP_OTHER_PROPERTIES.HAS_OTHER],
    hasCheckAll: [MAP_OTHER_PROPERTIES.HAS_CHECK_ALL],
    isHtml: [MAP_OTHER_PROPERTIES.IS_HTML],
    initialView: [MAP_OTHER_PROPERTIES.INITIAL_VIEW],
    description: [MAP_OTHER_PROPERTIES.DESCRIPTION],
    bottomDescription: [MAP_OTHER_PROPERTIES.BOTTOM_DESCRIPTION],
    adminDescription: [MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION],
    gradeList: [MAP_OTHER_PROPERTIES.GRADE_LIST],
    numberOfColumn: [MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN],
    textboxOption: [MAP_OTHER_PROPERTIES.TEXTBOX_OPTION],
    defaultValue: [
        MAP_OTHER_PROPERTIES.DEFAULT_OPTION,
        MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS,
        MAP_OTHER_PROPERTIES.DEFAULT_VALUE,
        MAP_OTHER_PROPERTIES.DEFAULT_VALUE_MULTI_LINES
    ],
    initialValue: [
        MAP_OTHER_PROPERTIES.INITIAL_VALUE
    ],
    hideSectionTitle: [MAP_OTHER_PROPERTIES.HIDE_SECTION_TITLE],
    showAtTop: [MAP_OTHER_PROPERTIES.SHOW_AT_TOP],
    hidePeriod: [MAP_OTHER_PROPERTIES.HIDE_SALARY_PERIOD],
    customizableItemList: [MAP_OTHER_PROPERTIES.CUSTOMIZABLE_ITEM_LIST],
    isShareModel: [MAP_OTHER_PROPERTIES.SHARE_MODEL],
    shareModelIndex: [MAP_OTHER_PROPERTIES.SHARE_MODEL],
    useDuplicateModel: [MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL],
    maxSize: [MAP_OTHER_PROPERTIES.MAX_FILE_SIZE],
    customLabels: [MAP_OTHER_PROPERTIES.CUSTOM_LABEL],
    customDateFormat: [MAP_OTHER_PROPERTIES.CUSTOM_DATE_FORMAT],
    searchable: [MAP_OTHER_PROPERTIES.SEARCHABLE],
    openOnSelect: [MAP_OTHER_PROPERTIES.OPEN_ON_SELECT],
    isArrayModel: [MAP_OTHER_PROPERTIES.IS_ARRAY_MODEL],
    useTimePicker: [MAP_OTHER_PROPERTIES.USE_TIME_PICKER],
    exclusiveOptions: [MAP_OTHER_PROPERTIES.EXCLUSIVE_OPTIONS],
    isPreconditionCheck: [MAP_OTHER_PROPERTIES.IS_PRECONDITION_CHECK],
    hasNote: [MAP_OTHER_PROPERTIES.HAS_NOTE],
    hasTimeOff: [MAP_OTHER_PROPERTIES.HAS_TIME_OFF],
    isShowDialog: [MAP_OTHER_PROPERTIES.MESSAGE_ON_CLICK],
    collapseByDefault: [MAP_OTHER_PROPERTIES.COLLAPSE_BY_DEFAULT],
    isPrivate: [MAP_OTHER_PROPERTIES.IS_PRIVATE],
    isAdminOnlySection: [MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY_SECTION],
    isAdminOnly: [MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY],
    scrollToNextItem: [MAP_OTHER_PROPERTIES.SCROLL_TO_NEXT_ITEM_ON_SELECT],
    showInAdminPanel: [MAP_OTHER_PROPERTIES.SHOW_IN_ADMIN_PANEL],
    showInInterviewPanel: [MAP_OTHER_PROPERTIES.SHOW_IN_INTERVIEW_PANEL],
    isHidden: [MAP_OTHER_PROPERTIES.IS_HIDDEN],
    hideDescriptionInViewScreen: [MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN],
    hideAdminDescriptionInViewScreen: [MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN],
    excludeChildrenQuestion: [MAP_OTHER_PROPERTIES.EXCLUDE_CHILDREN_QUESTION],
    excludeAddressQuestion: [MAP_OTHER_PROPERTIES.EXCLUDE_ADDRESS_QUESTION],
    hasNumberCandidateQuestion: [MAP_OTHER_PROPERTIES.HAS_NUMBER_CANDIDATE_QUESTION],
    hideAdditionalDateQuestion: [MAP_OTHER_PROPERTIES.HIDE_ADDITIONAL_DATES_QUESTION],
    hideLabel: [MAP_OTHER_PROPERTIES.HIDE_LABEL],
    excludeRepeatBooking: [MAP_OTHER_PROPERTIES.EXCLUDE_REPEAT_BOOKING],
    showDownloadFile: [MAP_OTHER_PROPERTIES.SHOW_DOWNLOAD_FILE],
    bookingRequirePaymentInfo: [MAP_OTHER_PROPERTIES.BOOKING_REQUIRE_PAYMENT_INFO],
    selectAllDaysForRecurringRequests: [MAP_OTHER_PROPERTIES.SELECT_ALL_DAYS_FOR_RECURRING_REQUESTS],
    chargeClientWhenAssignCandidate: [MAP_OTHER_PROPERTIES.CHARGE_CLIENT_WHEN_ASSIGN_CANDIDATE],
    minDurationAllowEditBooking: [MAP_OTHER_PROPERTIES.MIN_DURATION_ALLOW_EDIT_BOOKING],
    minDurationAllowAddBooking: [MAP_OTHER_PROPERTIES.MIN_DURATION_ALLOW_ADD_BOOKING],
    hideDetailLabel: [MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL],
    showInProfile: [MAP_OTHER_PROPERTIES.SHOW_IN_PROFILE],
    hideInProfile: [MAP_OTHER_PROPERTIES.HIDE_IN_PROFILE],
    showInEditProfile: [MAP_OTHER_PROPERTIES.SHOW_IN_EDIT_PROFILE],
    chargeOnSubmit: [MAP_OTHER_PROPERTIES.CHARGE_ON_SUBMIT],
    hasDerivedModel: [MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL],
    isIntegerField: [MAP_OTHER_PROPERTIES.IS_INTEGER_FIELD],
    isFloatField: [MAP_OTHER_PROPERTIES.IS_FLOAT_FIELD],
    notRequiredInApplication: [MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION],
    notInApplication: [MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
    showAge: [MAP_OTHER_PROPERTIES.SHOW_AGE],
    showPassedTime: [MAP_OTHER_PROPERTIES.SHOW_PASSED_TIMES],
    showPublicFormLink: [MAP_OTHER_PROPERTIES.SHOW_PUBLIC_FORM_LINK],
    showInCandidateView: [MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW],
    isUnique: [MAP_OTHER_PROPERTIES.IS_UNIQUE],
    isInPlacementInfoTab: [MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB],
    hasConfirmField: [MAP_OTHER_PROPERTIES.HAS_CONFIRM_FIELD],
    excludeFromSummaryEmail: [MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL],
    adminCanAddOption: [MAP_OTHER_PROPERTIES.ADMIN_CAN_ADD_OPTION],
    populateWeekAvailabilities: [MAP_OTHER_PROPERTIES.POPULATE_WEEK_AVAILABILITIES],
    canAddMultiple: [MAP_OTHER_PROPERTIES.CAN_ADD_MULTIPLE],
    isAPhoneNumber: [MAP_OTHER_PROPERTIES.IS_A_PHONE_NUMBER],
    onlyRequiredOneCheckedItem: [MAP_OTHER_PROPERTIES.ONLY_ONE_CHECKED_ITEM_REQUIRED]
};

export const LIST_BOOLEAN_OTHER_PROPERTY = [
    "hasOther", "hasCheckAll", "isHtml", "allowPastDate", "hideSectionTitle",
    "showAtTop", "hidePeriod", "customizableItemList", "isShareModel",
    "useDuplicateModel", "isOptional", "searchable", "openOnSelect", "isArrayModel",
    "useTimePicker", "isPreconditionCheck", "hasNote", "hasTimeOff", "isShowDialog",
    "collapseByDefault", "isPrivate", "isAdminOnlySection", "isAdminOnly",
    "scrollToNextItem", "showInAdminPanel", "showInInterviewPanel", "isHidden",
    "hideDescriptionInViewScreen", "hideAdminDescriptionInViewScreen", "isInPlacementInfoTab",
    "excludeChildrenQuestion", "excludeAddressQuestion", "hasNumberCandidateQuestion",
    "hideAdditionalDateQuestion", "hideLabel", "excludeRepeatBooking", "showDownloadFile",
    "bookingRequirePaymentInfo", "selectAllDaysForRecurringRequests", "hideDetailLabel", "showInProfile", "showInEditProfile", "hideInProfile",
    "chargeOnSubmit", "hasDerivedModel", "showPublicFormLink", "isIntegerField", "isFloatField",
    "notRequiredInApplication", "notInApplication", "showInCandidateView", "hasConfirmField", "excludeFromSummaryEmail",
    "isUnique", "adminCanAddOption", "chargeClientWhenAssignCandidate", "populateWeekAvailabilities", "showPassedTime", 
    "canAddMultiple", "isAPhoneNumber", "onlyRequiredOneCheckedItem"
];

export const MAP_REQUIRE_KEYS = {
    LABEL: "label",
    OPTION_LIST: "optionList",
    ITEM_LIST: "itemList",
    HEADER_LIST: "headerList",
    LIST_DAYS: "listDays",
    NAME: "name",
    SECTION_BUILDER_ID: "sectionBuilderId",
    FILE_INFO_BUILDER_ID: "fileInfoBuilderId",
    MODEL: "model",
    GRADE_LIST: "gradeList",
    DOCUMENT_TEMPLATE_ID: "documentTemplateId",
    EVALUATION_TEMPLATE_ID: "evaluationTemplateId",
    HTML_KEY: "html",
    LABEL_MODEL: "labelModel",
    PRODUCT_LIST: "productList",
    DESCRIPTION_LIST: "descriptionList",
    ICON_LIST: "iconList",
    PRICE_LIST: "priceList",
    HTML_LIST: "htmlList",
    CREDIT_NUMBER_LIST: "creditNumberList",
    OPTION: "option",
    LOG_ITEM: "logItem",
    CONFIRM_LABEL: "confirmLabel",
    PRESET_SECTION: "presetSection",
    PRESET_FIELDS: "presetFields",
    PAYMENT_TYPE: "paymentType",
    STEP_INDEX: "stepIndex",
    PLAN_ID_LIST: "planIdList",
};

export const MAP_DIALOG_SECTION = {
    People: {
        name: "People",
        api: "/api/people/",
        apiKey: "people"
    },
    Children: {
        name: "Children",
        api: "/api/children/",
        apiKey: "children"
    },
    Reference: {
        name: "Reference",
        api: "/api/references/",
        apiKey: "references"
    },
    Experience: {
        name: "Experience",
        api: "/api/experiences/",
        apiKey: "experiences"
    },
    Education: {
        name: "Education",
        api: "/api/education/",
        apiKey: "education"
    },
    Pet: {
        name: "Pet",
        api: "/api/pets/",
        apiKey: "pets"
    },
    Booking: {
        name: "Booking",
        api: "/api/jobs/",
        apiKey: "jobs"
    },
    Contact: {
        name: "Contact",
        api: "/api/contacts/",
        apiKey: "contacts"
    },
    Address: {
        name: "Address",
        api: "/api/addresses/",
        apiKey: "addresses"
    }
};

export const LIST_COMMON_FIELDS = [{
    id: FORM_TYPE.TEXTBOX,
    tooltip: "Textbox",
    icon: "text_fields",
},
{
    id: FORM_TYPE.TEXTAREA,
    tooltip: "Textarea",
    icon: "description",
},
{
    id: FORM_TYPE.RADIO,
    tooltip: "Radio",
    icon: "radio_button_checked",
},
{
    id: FORM_TYPE.CHECKBOX,
    tooltip: "Checkbox",
    icon: "check_box",
},
{
    id: FORM_TYPE.DATEPICKER,
    tooltip: "Date Picker",
    icon: "today",
},
{
    id: FORM_TYPE.MULTI_SELECT,
    tooltip: "Multi Select",
    icon: "library_add_check",
},
{
    id: FORM_TYPE.FILE,
    tooltip: "File",
    icon: "attach_file",
},
{
    id: FORM_TYPE.SUB_HEADER,
    tooltip: "Section Secondary Title",
    icon: "title",
},
{
    id: FORM_TYPE.HTML,
    tooltip: "HTML",
    icon: "code",
}
];

export const MAP_FIELD_TYPES = {
    TEXTBOX: {
        id: FORM_TYPE.TEXTBOX,
        value: "Textbox",
        icon: "text_fields",
        options: [
            MAP_OTHER_PROPERTIES.PLACE_HOLDER,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.DEFAULT_VALUE,
            MAP_OTHER_PROPERTIES.SHARE_MODEL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.IS_INTEGER_FIELD,
            MAP_OTHER_PROPERTIES.IS_FLOAT_FIELD,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.HAS_CONFIRM_FIELD,
            MAP_OTHER_PROPERTIES.IS_A_PHONE_NUMBER
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_TEXT],
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT, ...MODEL_EXPERIENCE_SELECTOR],
            Education: [
                ...MODEL_EDUCATION_SPECIFIC_TEXT,
                // ...MODEL_EDUCATION_SELECTOR
            ],
            Reference: [
                ...MODEL_REFERENCE_TEXT,
                ...MODEL_REFERENCE_SELECTOR,
                ...MODEL_REFERENCE_SPECIFIC_TEXT
            ],
            Children: [...MODEL_CHILDREN_SPECIFIC_TEXT, ...MODEL_CHILDREN_TEXT],
            Contact: [...MODEL_CONTACT_SPECIFIC_TEXT, ...MODEL_CONTACT_TEXT],
            Address: [...MODEL_ADDRESS_SPECIFIC_TEXT, ...MODEL_ADDRESS_TEXT],
            Pet: [...MODEL_PET_TEXT, ...MODEL_PET_SPECIFIC_TEXT],
            Booking: [...MODEL_BOOKING_TEXT],
            FileInfo: [...MODEL_FILE_INFO_SPECIFIC_TEXT, ...MODEL_FILE_INFO_SELECTOR],
            JobApplication: ['message'],
            Relationship: MODEL_RELATIONSHIP_TEXT,
            Default: [...MODEL_TEXT, ...MODEL_SPECIFIC_TEXT, ...MODEL_INTEGER_FIELD, ...MODEL_FLOAT_FIELD, ...MODEL_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    TEXTAREA: {
        id: FORM_TYPE.TEXTAREA,
        value: "Textarea",
        icon: "description",
        options: [
            MAP_OTHER_PROPERTIES.PLACE_HOLDER,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.DEFAULT_VALUE_MULTI_LINES,
            MAP_OTHER_PROPERTIES.SHARE_MODEL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_TEXT],
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT, ...MODEL_EXPERIENCE_SELECTOR],
            Education: [
                ...MODEL_EDUCATION_SPECIFIC_TEXT,
                // ...MODEL_EDUCATION_SELECTOR
            ],
            Reference: [
                ...MODEL_REFERENCE_TEXT,
                ...MODEL_REFERENCE_SELECTOR,
                ...MODEL_REFERENCE_SPECIFIC_TEXT
            ],
            Children: [...MODEL_CHILDREN_SPECIFIC_TEXT, ...MODEL_CHILDREN_TEXT],
            Contact: [...MODEL_CONTACT_SPECIFIC_TEXT, ...MODEL_CONTACT_TEXT],
            Address: [...MODEL_ADDRESS_SPECIFIC_TEXT, ...MODEL_ADDRESS_TEXT],
            Pet: [...MODEL_PET_TEXT, ...MODEL_PET_SPECIFIC_TEXT],
            Booking: [...MODEL_BOOKING_TEXT],
            FileInfo: [...MODEL_FILE_INFO_SPECIFIC_TEXT, ...MODEL_FILE_INFO_SELECTOR],
            JobApplication: ['message'],
            Relationship: MODEL_RELATIONSHIP_TEXT,
            Default: [...MODEL_TEXT, ...MODEL_SPECIFIC_TEXT]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    RADIO: {
        id: FORM_TYPE.RADIO,
        value: "Radio",
        isSelection: true,
        icon: "radio_button_checked",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.HAS_OTHER,
            MAP_OTHER_PROPERTIES.DEFAULT_OPTION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.BOTTOM_DESCRIPTION,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.SHARE_MODEL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN,
            MAP_OTHER_PROPERTIES.IS_HTML,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.IS_HIDDEN,
            MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.ADMIN_CAN_ADD_OPTION
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_TEXT, ...MODEL_REFERENCE_CHECK_SELECTOR, "rating"],
            Reference: [...MODEL_REFERENCE_SELECTOR, "rating", ...MODEL_REFERENCE_SPECIFIC_TEXT],
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT, ...MODEL_EXPERIENCE_SELECTOR],
            Education: [...MODEL_EDUCATION_SELECTOR],
            Children: [...MODEL_CHILDREN_SELECTOR, "gender"],
            Pet: [...MODEL_PET_SPECIFIC_SELECTOR],
            Booking: [...MODEL_BOOKING_SELECTOR],
            Contact: [...MODEL_CONTACT_SELECTOR],
            Address: [...MODEL_ADDRESS_SPECIFIC_TEXT, ...MODEL_ADDRESS_TEXT, ...MODEL_ADDRESS_SELECTOR],
            FileInfo: [...MODEL_FILE_INFO_SELECTOR],
            JobApplication: ['message'],
            Relationship: MODEL_RELATIONSHIP_TEXT,
            Default: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR, ...MODEL_BOOLEAN_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    RADIO_ICON: {
        id: FORM_TYPE.RADIO_ICON,
        value: "Radio Icon",
        isSelection: true,
        icon: "radio_button_checked",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DEFAULT_OPTION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.BOTTOM_DESCRIPTION,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.SHARE_MODEL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_TEXT, ...MODEL_REFERENCE_CHECK_SELECTOR, "rating"],
            Reference: [...MODEL_REFERENCE_SELECTOR, "rating", ...MODEL_REFERENCE_SPECIFIC_TEXT],
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT, ...MODEL_EXPERIENCE_SELECTOR],
            Education: [...MODEL_EDUCATION_SELECTOR],
            Children: [...MODEL_CHILDREN_SELECTOR, "gender"],
            Pet: [...MODEL_PET_SPECIFIC_SELECTOR],
            Booking: [...MODEL_BOOKING_SELECTOR],
            Contact: [...MODEL_CONTACT_SELECTOR],
            Address: [...MODEL_ADDRESS_SPECIFIC_TEXT, ...MODEL_ADDRESS_TEXT, ...MODEL_ADDRESS_SELECTOR],
            FileInfo: [...MODEL_FILE_INFO_SELECTOR],
            Default: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR, ...MODEL_BOOLEAN_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST, MAP_REQUIRE_KEYS.ICON_LIST]
    },
    CHECKBOX_ITEM: {
        id: FORM_TYPE.CHECKBOX_ITEM,
        value: "Checkbox Item (Single Checkbox)",
        isSelection: true,
        icon: "check",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.MESSAGE_ON_CLICK,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_TEXT, ...MODEL_REFERENCE_CHECK_SELECTOR, "rating"],
            Reference: [...MODEL_REFERENCE_SELECTOR, "rating", ...MODEL_REFERENCE_SPECIFIC_TEXT],
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT, ...MODEL_EXPERIENCE_SELECTOR],
            Education: [...MODEL_EDUCATION_SELECTOR],
            Children: [...MODEL_CHILDREN_SELECTOR, "gender"],
            Pet: [...MODEL_PET_SPECIFIC_SELECTOR],
            Booking: [...MODEL_BOOKING_SELECTOR],
            Contact: [...MODEL_CONTACT_SELECTOR],
            Address: [...MODEL_ADDRESS_SPECIFIC_TEXT, ...MODEL_ADDRESS_TEXT, ...MODEL_ADDRESS_SELECTOR],
            FileInfo: [...MODEL_FILE_INFO_SELECTOR],
            JobApplication: ['message'],
            Relationship: MODEL_RELATIONSHIP_TEXT,
            Default: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LABEL]
    },
    CHECKBOX: {
        id: FORM_TYPE.CHECKBOX,
        value: "Checkbox Group",
        isSelection: true,
        icon: "check_box",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.HAS_OTHER,
            MAP_OTHER_PROPERTIES.HAS_CHECK_ALL,
            MAP_OTHER_PROPERTIES.IS_HTML,
            MAP_OTHER_PROPERTIES.TEXTBOX_OPTION,
            MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN,
            MAP_OTHER_PROPERTIES.EXCLUSIVE_OPTIONS,
            MAP_OTHER_PROPERTIES.MESSAGE_ON_CLICK,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.IS_HIDDEN,
            MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.ADMIN_CAN_ADD_OPTION
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_MULTISELECT],
            Reference: [...MODEL_REFERENCE_MULTISELECT],
            Experience: [...MODEL_EXPERIENCE_MULTISELECT],
            Booking: [...MODEL_BOOKING_MULTISELECT],
            JobApplication: [], Relationship: [],
            Default: [...MODEL_MULTI_SELECT],
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    CHECKBOX_ICON: {
        id: FORM_TYPE.CHECKBOX_ICON,
        value: "Checkbox Icon",
        isSelection: true,
        icon: "check_box",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.HAS_OTHER,
            MAP_OTHER_PROPERTIES.HAS_CHECK_ALL,
            MAP_OTHER_PROPERTIES.IS_HTML,
            MAP_OTHER_PROPERTIES.TEXTBOX_OPTION,
            MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_MULTISELECT],
            Reference: [...MODEL_REFERENCE_MULTISELECT],
            Experience: [...MODEL_EXPERIENCE_MULTISELECT],
            Booking: [...MODEL_BOOKING_MULTISELECT],
            Default: [...MODEL_MULTI_SELECT],
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    SALARY_RANGE: {
        id: FORM_TYPE.SALARY_RANGE,
        value: "Salary Range",
        isSelection: false,
        icon: "check_box",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.HAS_OTHER,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.TEXTBOX_OPTION,
            MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS,
            MAP_OTHER_PROPERTIES.HIDE_SALARY_PERIOD,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: { Default: MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    DATEPICKER: {
        id: FORM_TYPE.DATEPICKER,
        value: "Date Picker",
        icon: "today",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.INITIAL_VIEW,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.SHOW_AGE, MAP_OTHER_PROPERTIES.SHOW_PASSED_TIMES,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.CUSTOM_DATE_FORMAT,
            MAP_OTHER_PROPERTIES.APPEND_TO_BODY
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        models: {
            Experience: MODEL_EXPERIENCE_DATE,
            Reference: MODEL_REFERENCE_DATE,
            Education: MODEL_EDUCATION_DATE,
            ReferenceCheck: [],
            Children: MODEL_CHILDREN_DATE,
            Booking: MODEL_BOOKING_DATE,
            FileInfo: MODEL_FILE_INFO_DATE,
            JobApplication: [], Relationship: [],
            Default: MODEL_DATE
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    MULTI_DATEPICKER: {
        id: FORM_TYPE.MULTI_DATEPICKER,
        value: "Multi Date Picker",
        isSelection: true,
        icon: "date_range",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Experience: [...MODEL_EXPERIENCE_MULTISELECT],
            Reference: [...MODEL_REFERENCE_MULTISELECT],
            Booking: [...MODEL_BOOKING_MULTISELECT],
            Default: [...MODEL_MULTI_SELECT],
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.NAME]
    },
    TIMEPICKER: {
        id: FORM_TYPE.TIME_PICKER,
        value: "Time Picker",
        icon: "query_builder",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.MINUTES_INTERVAL, MAP_OTHER_PROPERTIES.IS_24_HOUR_FORMAT,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.DEFAULT_TIME
        ],
        models: {
            Booking: MODEL_BOOKING_TIME_PICKER,
            JobApplication: [], Relationship: [],
            Default: MODEL_TIME_PICKER
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    DATETIME_PICKER: {
        id: FORM_TYPE.DATETIME_PICKER,
        value: "Date Time Picker",
        icon: "watch_later",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.INITIAL_VIEW,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.MINUTES_INTERVAL, MAP_OTHER_PROPERTIES.IS_24_HOUR_FORMAT,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Reference: ["check_completion_date"],
            ReferenceCheck: ["check_completion_date"],
            JobApplication: [], Relationship: [],
            Default: []
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    MONTHPICKER: {
        id: FORM_TYPE.MONTH_PICKER,
        value: "Month Picker",
        icon: "event",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.INITIAL_VIEW,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Experience: MODEL_EXPERIENCE_DATE,
            Reference: MODEL_REFERENCE_DATE,
            Education: MODEL_EDUCATION_DATE,
            Children: MODEL_CHILDREN_DATE,
            Booking: MODEL_BOOKING_DATE,
            FileInfo: MODEL_FILE_INFO_DATE,
            JobApplication: [], Relationship: [],
            Default: MODEL_DATE
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    YEAR_PICKER: {
        id: FORM_TYPE.YEAR_PICKER,
        value: "Year Picker",
        icon: "school",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT, ...MODEL_EXPERIENCE_SELECTOR],
            Education: [...MODEL_EDUCATION_SELECTOR],
            Children: [...MODEL_CHILDREN_SELECTOR],
            Pet: [...MODEL_PET_SPECIFIC_SELECTOR],
            Booking: [...MODEL_BOOKING_SELECTOR],
            Contact: [...MODEL_CONTACT_SELECTOR],
            FileInfo: [...MODEL_FILE_INFO_SELECTOR],
            JobApplication: [], Relationship: [],
            Default: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    TIME_TABLE: {
        id: FORM_TYPE.DAY_HOURS_SELECTOR,
        value: "Time Availability",
        icon: "event_available",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.MINUTES_INTERVAL, MAP_OTHER_PROPERTIES.IS_24_HOUR_FORMAT,
            MAP_OTHER_PROPERTIES.CUSTOM_LABEL,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.USE_TIME_PICKER,
            MAP_OTHER_PROPERTIES.HAS_NOTE,
            MAP_OTHER_PROPERTIES.HAS_TIME_OFF,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.POPULATE_WEEK_AVAILABILITIES
        ],
        models: { Default: MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LIST_DAYS]
    },
    DROPDOWN: {
        id: FORM_TYPE.DROPDOWN,
        value: "Dropdown",
        isSelection: true,
        icon: "arrow_drop_down_circle_outlined",
        options: [
            MAP_OTHER_PROPERTIES.PLACE_HOLDER,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DEFAULT_OPTION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.SHARE_MODEL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_TEXT, ...MODEL_REFERENCE_CHECK_SELECTOR, "rating"],
            Reference: [...MODEL_REFERENCE_SELECTOR, "rating"],
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT],
            Children: [...MODEL_CHILDREN_SELECTOR, "gender"],
            Pet: [...MODEL_PET_SPECIFIC_SELECTOR],
            Booking: [...MODEL_BOOKING_SELECTOR],
            Contact: [...MODEL_CONTACT_SELECTOR],
            Address: [...MODEL_ADDRESS_SPECIFIC_TEXT, ...MODEL_ADDRESS_TEXT, ...MODEL_ADDRESS_SELECTOR],
            FileInfo: [...MODEL_FILE_INFO_SELECTOR],
            Education: [
                ...MODEL_EDUCATION_SPECIFIC_TEXT,
                ...MODEL_EDUCATION_SELECTOR
            ],
            JobApplication: [], Relationship: [],
            Default: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    MULTISELECT: {
        id: FORM_TYPE.MULTI_SELECT,
        value: "Multi-Select",
        isSelection: true,
        icon: "library_add_check",
        options: [
            MAP_OTHER_PROPERTIES.PLACE_HOLDER,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.SEARCHABLE,
            MAP_OTHER_PROPERTIES.OPEN_ON_SELECT,
            MAP_OTHER_PROPERTIES.IS_ARRAY_MODEL,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.DEFAULT_MULTI_OPTIONS,
            MAP_OTHER_PROPERTIES.INITIAL_VALUE,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.HAS_DERIVED_MODEL,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.ADMIN_CAN_ADD_OPTION,
            MAP_OTHER_PROPERTIES.HAS_OTHER,
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_MULTISELECT],
            ReferenceCheck_Single: [...MODEL_REFERENCE_CHECK_TEXT, ...MODEL_REFERENCE_CHECK_SELECTOR, "rating"],
            Reference: [...MODEL_REFERENCE_MULTISELECT],
            Reference_Single: [...MODEL_REFERENCE_SELECTOR, "rating", "status"],
            Experience: [...MODEL_EXPERIENCE_MULTISELECT],
            Experience_Single: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT, ...MODEL_EXPERIENCE_SELECTOR],
            Booking: [...MODEL_BOOKING_MULTISELECT],
            Booking_Single: [...MODEL_BOOKING_SELECTOR, ...MODEL_BOOKING_TEXT],
            Pet_Single: [...MODEL_PET_SPECIFIC_SELECTOR],
            Contact_Single: [...MODEL_CONTACT_SELECTOR],
            Address_Single: [...MODEL_ADDRESS_SPECIFIC_TEXT, ...MODEL_ADDRESS_TEXT, ...MODEL_ADDRESS_SELECTOR],
            Default: MODEL_MULTI_SELECT,
            JobApplication: [], Relationship: [],
            JobApplication_Single: [],
            Default_Single: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    FILE: {
        id: FORM_TYPE.FILE,
        value: "File",
        icon: "attach_file",
        options: [
            MAP_OTHER_PROPERTIES.FILE_TYPE,
            MAP_OTHER_PROPERTIES.MAX_FILE_SIZE,
            MAP_OTHER_PROPERTIES.SHOW_AT_TOP,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.BLANK_FILE_URL,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Pet: ["pic", "file1", "file2"],
            Reference: MODEL_REFERENCE_FILE,
            ReferenceCheck: MODEL_REFERENCE_FILE,
            Experience: MODEL_EXPERIENCE_FILE,
            Booking: MODEL_BOOKING_FILE,
            Default: MODEL_FILE_ALL
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    LABEL: {
        id: FORM_TYPE.LABEL,
        value: "Label",
        icon: "label",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Default: ["Present"]
        },
        requireKeys: []
    },
    LIST_ITEMS: {
        id: FORM_TYPE.LIST_ITEMS,
        value: "List Items",
        icon: "list",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        requireKeys: [MAP_REQUIRE_KEYS.ITEM_LIST]
    },
    SECTION: {
        id: FORM_TYPE.SECTION,
        value: "Section",
        icon: "view_list",
        options: [
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.HIDE_SECTION_TITLE,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.IS_PRECONDITION_CHECK,
            MAP_OTHER_PROPERTIES.COLLAPSE_BY_DEFAULT,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY_SECTION,
            MAP_OTHER_PROPERTIES.SHOW_IN_ADMIN_PANEL,
            MAP_OTHER_PROPERTIES.SHOW_IN_INTERVIEW_PANEL,
            MAP_OTHER_PROPERTIES.SHOW_DOWNLOAD_FILE,
            MAP_OTHER_PROPERTIES.SHOW_PUBLIC_FORM_LINK,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.SECTION_BUILDER_ID]
    },
    PRESET_SECTION: {
        id: FORM_TYPE.PRESET_SECTION,
        value: "Preset Section",
        icon: "view_stream",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.IS_PRIVATE
        ],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.PRESET_SECTION]
    },
    PRESET_FIELDS: {
        id: FORM_TYPE.PRESET_FIELDS,
        value: "Preset Fields",
        icon: "view_stream",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.PRESET_FIELDS]
    },
    BOOKING_SECTION: {
        id: FORM_TYPE.BOOKING_SECTION,
        value: "Booking Section",
        icon: "event_available",
        options: [
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.HIDE_SECTION_TITLE,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.EXCLUDE_CHILDREN_QUESTION,
            MAP_OTHER_PROPERTIES.EXCLUDE_ADDRESS_QUESTION,
            MAP_OTHER_PROPERTIES.SELECT_ALL_DAYS_FOR_RECURRING_REQUESTS,
            MAP_OTHER_PROPERTIES.EXCLUDE_REPEAT_BOOKING,
            MAP_OTHER_PROPERTIES.HAS_NUMBER_CANDIDATE_QUESTION,
            MAP_OTHER_PROPERTIES.HIDE_ADDITIONAL_DATES_QUESTION,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.MIN_DURATION_ALLOW_ADD_BOOKING
        ],
        optionsProfile: [
            MAP_OTHER_PROPERTIES.BOOKING_REQUIRE_PAYMENT_INFO,
            MAP_OTHER_PROPERTIES.SELECT_ALL_DAYS_FOR_RECURRING_REQUESTS,
            MAP_OTHER_PROPERTIES.MIN_DURATION_ALLOW_EDIT_BOOKING,
            MAP_OTHER_PROPERTIES.CHARGE_CLIENT_WHEN_ASSIGN_CANDIDATE
        ],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.SECTION_BUILDER_ID]
    },
    HEADER: {
        id: FORM_TYPE.HEADER,
        value: "Section Title",
        icon: "title_outlined",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL]
    },
    SUB_HEADER: {
        id: FORM_TYPE.SUB_HEADER,
        value: "Section Secondary Title",
        icon: "title",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL]
    },
    HTML: {
        id: FORM_TYPE.HTML,
        value: "HTML",
        icon: "code",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.SHOW_IN_PROFILE,
            MAP_OTHER_PROPERTIES.SHOW_IN_EDIT_PROFILE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
        ],
        optionsBooking: [
            MAP_OTHER_PROPERTIES.IS_UNIQUE,
            MAP_OTHER_PROPERTIES.SHOW_IN_CANDIDATE_VIEW
        ],
        optionPlacementJob: [
            MAP_OTHER_PROPERTIES.IS_IN_PLACEMENT_INFO_TAB
        ],
        requireKeys: [MAP_REQUIRE_KEYS.HTML_KEY]
    },
    RATING_GROUP: {
        id: FORM_TYPE.RATING_GROUP,
        value: "Rating Group",
        icon: "grading",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.GRADE_LIST,
            MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: { Default: MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.ITEM_LIST]
    },
    RADIO_TABLE: {
        id: FORM_TYPE.RADIO_TABLE,
        value: "Radio Table",
        icon: "playlist_add_check",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            ReferenceCheck: MODEL_REFERENCE_CHECK_MULTISELECT,
            Default: MODEL_MULTI_SELECT
        },
        requireKeys: [
            MAP_REQUIRE_KEYS.MODEL,
            MAP_REQUIRE_KEYS.OPTION_LIST,
            MAP_REQUIRE_KEYS.ITEM_LIST
        ]
    },
    CHECKBOX_TABLE: {
        id: FORM_TYPE.CHECKBOX_TABLE,
        value: "Checkbox Table",
        icon: "checklist",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.CUSTOMIZABLE_ITEM_LIST, MAP_OTHER_PROPERTIES.HAS_NOTE,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION, MAP_OTHER_PROPERTIES.ONLY_ONE_CHECKED_ITEM_REQUIRED
        ],
        models: { Default: MODEL_MULTI_SELECT },
        requireKeys: [
            MAP_REQUIRE_KEYS.MODEL,
            MAP_REQUIRE_KEYS.OPTION_LIST,
            MAP_REQUIRE_KEYS.ITEM_LIST
        ]
    },
    LANGUAGE_INPUT: {
        id: FORM_TYPE.LANGUAGE_INPUT,
        value: "Language Input",
        icon: "language",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: { Default: MODEL_MULTI_SELECT },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST]
    },
    SEPARATOR: {
        id: FORM_TYPE.SEPARATOR,
        value: "Separator",
        icon: "horizontal_rule",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION]
    },
    TEXT_EDITOR: {
        id: FORM_TYPE.TEXT_EDITOR,
        value: "Text Editor",
        icon: "article",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.DEFAULT_VALUE_MULTI_LINES,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT],
            Education: MODEL_EDUCATION_SPECIFIC_TEXT,
            Reference: [...MODEL_REFERENCE_TEXT, ...MODEL_REFERENCE_SPECIFIC_TEXT],
            Children: [...MODEL_CHILDREN_TEXT, ...MODEL_CHILDREN_SPECIFIC_TEXT],
            Contact: [...MODEL_CONTACT_SPECIFIC_TEXT, ...MODEL_CONTACT_TEXT],
            Address: [...MODEL_ADDRESS_SPECIFIC_TEXT, ...MODEL_ADDRESS_TEXT],
            Booking: [...MODEL_BOOKING_TEXT],
            JobApplication: ['message'],
            Relationship: MODEL_RELATIONSHIP_TEXT,
            Default: MODEL_TEXT
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    SIGN_DOCUMENT: {
        id: FORM_TYPE.SIGN_DOCUMENT,
        value: "Sign Document",
        icon: "gesture_rounded",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.HIDE_LABEL, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.DOCUMENT_TEMPLATE_ID]
    },
    FILE_WITH_INFO: {
        id: FORM_TYPE.FILE_WITH_INFO,
        value: "File With Additional Information",
        icon: "attachment",
        options: [
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.HIDE_SECTION_TITLE,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.BLANK_FILE_URL,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
            MAP_OTHER_PROPERTIES.INFO_ONCE_EXPIRED, MAP_OTHER_PROPERTIES.CAN_ADD_MULTIPLE
        ],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL]
    },
    LIST_TEXTBOX: {
        id: FORM_TYPE.LIST_TEXTBOX,
        value: "List Textbox",
        isSelection: true,
        icon: "reorder",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Experience: [...MODEL_EXPERIENCE_MULTISELECT],
            Reference: [...MODEL_REFERENCE_MULTISELECT],
            Booking: [...MODEL_BOOKING_MULTISELECT],
            Default: [...MODEL_MULTI_SELECT],
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LABEL_MODEL]
    },
    CHECKBOX_CONDITION: {
        id: FORM_TYPE.CHECKBOX_CONDITION,
        value: "Checkbox Condition",
        icon: "check_circle",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.OPTION_LIST, MAP_REQUIRE_KEYS.LABEL]
    },
    PRODUCT_SELECTION: {
        id: FORM_TYPE.PRODUCT_SELECTION,
        value: "Product Selection",
        icon: "how_to_reg",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.IS_ARRAY_MODEL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Experience: [...MODEL_EXPERIENCE_MULTISELECT],
            Reference: [...MODEL_REFERENCE_MULTISELECT],
            Booking: [...MODEL_BOOKING_MULTISELECT],
            Booking_Single: [...MODEL_BOOKING_SELECTOR],
            Pet_Single: [...MODEL_PET_SPECIFIC_SELECTOR],
            Contact_Single: [...MODEL_CONTACT_SELECTOR],
            Default: MODEL_MULTI_SELECT,
            Default_Single: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR]
        },
        requireKeys: [
            MAP_REQUIRE_KEYS.PRODUCT_LIST,
            MAP_REQUIRE_KEYS.ICON_LIST,
            MAP_REQUIRE_KEYS.DESCRIPTION_LIST,
            MAP_REQUIRE_KEYS.PRICE_LIST,
            MAP_REQUIRE_KEYS.MODEL
        ]
    },
    CREDIT_PACKAGE_SELECTION: {
        id: FORM_TYPE.CREDIT_PACKAGE_SELECTION,
        value: "Credit Package Condition",
        icon: "account_balance",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
        MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [
            MAP_REQUIRE_KEYS.HTML_LIST, MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.CREDIT_NUMBER_LIST,
            MAP_REQUIRE_KEYS.PRICE_LIST
        ]
    },
    STRIPE_SUBSCRIPTION_SELECTION: {
        id: FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION,
        value: "Stripe Subscription Selection",
        icon: "S",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
        MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [
            MAP_REQUIRE_KEYS.HEADER_LIST, MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.PLAN_ID_LIST,
        ]
    },
    RATING: {
        id: FORM_TYPE.RATING,
        value: "Rating",
        isSelection: true,
        icon: "star_rate",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.HAS_OTHER,
            MAP_OTHER_PROPERTIES.DEFAULT_OPTION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_TEXT, ...MODEL_REFERENCE_CHECK_SELECTOR, "rating"],
            Reference: [...MODEL_REFERENCE_SELECTOR, "rating"],
            Experience: [...MODEL_EXPERIENCE_TEXT, ...MODEL_EXPERIENCE_SPECIFIC_TEXT, ...MODEL_EXPERIENCE_SELECTOR],
            Education: [...MODEL_EDUCATION_SELECTOR],
            Children: [...MODEL_CHILDREN_SELECTOR, "gender"],
            Pet: [...MODEL_PET_SPECIFIC_SELECTOR],
            Booking: [...MODEL_BOOKING_SELECTOR],
            Contact: [...MODEL_CONTACT_SELECTOR],
            FileInfo: [...MODEL_FILE_INFO_SELECTOR],
            Default: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR, ...MODEL_BOOLEAN_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
    HTML_SELECTION: {
        id: FORM_TYPE.HTML_SELECTION,
        value: "HTML Selection",
        isSelection: true,
        icon: "price_check",
        options: [
            MAP_OTHER_PROPERTIES.PLACE_HOLDER,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.NUMBER_OF_COLUMN,
            MAP_OTHER_PROPERTIES.MESSAGE_ON_CLICK,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.SCROLL_TO_NEXT_ITEM_ON_SELECT,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_MULTISELECT],
            ReferenceCheck_Single: [...MODEL_REFERENCE_CHECK_TEXT, ...MODEL_REFERENCE_CHECK_SELECTOR, "rating"],
            Reference: [...MODEL_REFERENCE_MULTISELECT],
            Reference_Single: [...MODEL_REFERENCE_SELECTOR, "rating"],
            Experience: [...MODEL_EXPERIENCE_MULTISELECT],
            Booking: [...MODEL_BOOKING_MULTISELECT],
            Booking_Single: [...MODEL_BOOKING_SELECTOR],
            Pet_Single: [...MODEL_PET_SPECIFIC_SELECTOR],
            Contact_Single: [...MODEL_CONTACT_SELECTOR],
            Default: MODEL_MULTI_SELECT,
            Default_Single: [...MODEL_SELECTOR, ...MODEL_SPECIFIC_SELECTOR]
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.OPTION_LIST, MAP_REQUIRE_KEYS.HTML_LIST]
    },
    EXPRESSION: {
        id: FORM_TYPE.EXPRESSION,
        value: "Display Value by Expression",
        icon: "functions"
    },
    PAYMENT: {
        id: FORM_TYPE.PAYMENT,
        value: "Payment",
        icon: "payment",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.CHARGE_ON_SUBMIT,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        requireKeys: [MAP_REQUIRE_KEYS.PAYMENT_TYPE]
    },
    LOGGING: {
        id: FORM_TYPE.LOGGING,
        value: "Auto Log",
        icon: "update",
        options: [MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_TEXT, "check_completion_date"],
            Default: [
                ...MODEL_TEXT
            ]
        },
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LOG_ITEM]
    },
    PASSWORD: {
        id: FORM_TYPE.PASSWORD,
        value: "Password",
        icon: "password",
        options: [
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.USE_DUPLICATE_MODEL, MAP_OTHER_PROPERTIES.HIDE_IN_PROFILE,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION
        ],
        models: {
            Default: ['password']
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL, MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.CONFIRM_LABEL]
    },
    PLACEMENT_JOB_SELECTION: {
        id: FORM_TYPE.PLACEMENT_JOB_SELECTION,
        value: "Placement Job Selection",
        icon: "work"
    },
    EVALUATION: {
        id: FORM_TYPE.EVALUATION,
        value: "Evaluation",
        icon: "quiz",
        options: [MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION, MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE, MAP_OTHER_PROPERTIES.HIDE_LABEL, MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION],
        requireKeys: [MAP_REQUIRE_KEYS.LABEL, MAP_REQUIRE_KEYS.EVALUATION_TEMPLATE_ID]
    },
    VIDEO: {
        id: FORM_TYPE.VIDEO,
        value: "Video Recorder",
        icon: "videocam",
        models: {
            Default: ['video_id']
        },
    },
    RETURNING_APPLICANT_BTN: {
        id: FORM_TYPE.RETURNING_APPLICANT_BTN,
        value: "Returning Applicant Button",
        icon: "assignment_return"
    },
    SIGNATURE_FIELD: {
        id: FORM_TYPE.SIGNATURE_FIELD,
        value: "Signature Field",
        icon: "gesture",
        options: [
            MAP_OTHER_PROPERTIES.PLACE_HOLDER,
            MAP_OTHER_PROPERTIES.SHOW_CONDITION, MAP_OTHER_PROPERTIES.SHOW_CONDITION_ADVANCE, MAP_OTHER_PROPERTIES.SECONDARY_SHOW_CONDITION, MAP_OTHER_PROPERTIES.THIRD_SHOW_CONDITION,
            MAP_OTHER_PROPERTIES.DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_DETAIL_LABEL, MAP_OTHER_PROPERTIES.HIDE_DESCRIPTION_IN_VIEW_SCREEN,
            MAP_OTHER_PROPERTIES.ADMIN_DESCRIPTION, MAP_OTHER_PROPERTIES.HIDE_ADMIN_DESCRIPTION_IN_VIEW_SCREEN, MAP_OTHER_PROPERTIES.EXCLUDE_FROM_SUMMARY_EMAIL,
            MAP_OTHER_PROPERTIES.IS_ADMIN_ONLY, MAP_OTHER_PROPERTIES.IS_PRIVATE,
            MAP_OTHER_PROPERTIES.NOT_REQUIRED_IN_APPLICATION, MAP_OTHER_PROPERTIES.NOT_IN_APPLICATION,
        ],
        models: {
            ReferenceCheck: [...MODEL_REFERENCE_CHECK_MULTISELECT],
            Reference: [...MODEL_REFERENCE_MULTISELECT],
            Experience: [...MODEL_EXPERIENCE_MULTISELECT],
            Booking: [...MODEL_BOOKING_MULTISELECT],
            JobApplication: [], Relationship: [],
            Default: [...MODEL_MULTI_SELECT],
        },
        requireKeys: [MAP_REQUIRE_KEYS.MODEL]
    },
};


// WEBPACK FOOTER //
// ./src/constants/field-types.js